import { Modal } from '@theme/global';
import { animate } from '@theme/m';

const EASE = [0.19, 1, 0.22, 1];
const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

/**
 * If the animation cannot run, the dialog must still end up visible — an
 * uncaught error here would leave it open, untransformed and unclosable.
 */
function safeAnimate(el, keyframes, options) {
  try {
    return animate(el, keyframes, options);
  } catch (error) {
    console.warn('[guarantee-badge] animation failed, showing dialog directly', error);
    el.style.transform = '';
    el.style.opacity = '';
    return { complete() {}, then: (onDone) => Promise.resolve().then(onDone) };
  }
}

/**
 * Dialog for the 30-Day Money-Back Guarantee badge.
 * Slides up from the bottom on mobile, fades in centered on desktop.
 */
class GuaranteeModal extends Modal {
  animateDialogOpen() {
    return isMobile()
      ? safeAnimate(this.dialog, {
          transform: ['translateY(100%)', 'translateY(0)'],
        }, { duration: 0.45, ease: EASE })
      : safeAnimate(this.dialog, {
          opacity: [0, 1],
          transform: ['translateY(2rem) scale(0.97)', 'translateY(0) scale(1)'],
        }, { duration: 0.35, ease: EASE });
  }

  animateDialogClose() {
    return isMobile()
      ? safeAnimate(this.dialog, {
          transform: ['translateY(0)', 'translateY(100%)'],
        }, { duration: 0.35, ease: EASE })
      : safeAnimate(this.dialog, {
          opacity: [1, 0],
          transform: ['translateY(0) scale(1)', 'translateY(2rem) scale(0.97)'],
        }, { duration: 0.3, ease: EASE });
  }
}

if (!customElements.get('hdt-guarantee-modal')) {
  customElements.define('hdt-guarantee-modal', GuaranteeModal);
}
